// extracted by mini-css-extract-plugin
export default {"cssBreakpointExpandedFilters":"1230px"};